let StickyNavigation = function () {
    let initialize = function (el) {
        let $this = $(el);

        $(window).scroll(function () {
            let className = 'sticky';
            let stickyNavTop = $this.parent().offset().top;
            let scrollTop = $(window).scrollTop();

            if (scrollTop > stickyNavTop) {
                $this.addClass(className);
            } else {
                $this.removeClass(className);
            }
        });
    };

    return {
        init: initialize
    }
};

export default function (el) {
    let sticky = new StickyNavigation();
    sticky.init(el);
    return sticky;
};
